<template>
  <v-dialog :value="value" @click:outside="stopAndClose" content-class="noscroll video">
    <v-toolbar dense dark color="secondary">
      <v-icon left>fa-solid fa-signs-post</v-icon>
      <v-toolbar-title>
        {{ selectedVideo ? selectedVideo.title : 'Guide Me' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu bottom left offset-y v-if="videos && videos.length > 1">
          <template v-slot:activator="{ on, attrs }">
            <v-btn small text v-bind="attrs" v-on="on">
              <v-icon small left>fa-regular fa-file-video</v-icon>Available Videos
            </v-btn>
          </template>
          <v-list>
            <v-subheader inset>Topic Videos</v-subheader>
            <v-list-item v-for="item in specificVideos" :key="item.video" @click="selectVideo(item)">
              <v-list-item-icon>
                <v-icon>fa-regular fa-file-video</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="moiVideos && moiVideos.length > 0"></v-divider>
            <v-subheader v-if="moiVideos && moiVideos.length > 0" inset>Maybe of Interest</v-subheader>
            <v-list-item v-for="item in moiVideos" :key="item.video" @click="selectVideo(item)">
              <v-list-item-icon>
                <v-icon>fa-regular fa-file-video</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn icon small @click="stopAndClose">
          <v-icon small>fa-xmark</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card class="videocard" v-if="value">
      <vue-plyr ref="plyr">
        <div
          v-if="!hasPath"
          data-plyr-provider="youtube"
          :data-plyr-embed-id="selectedVideo ? selectedVideo.video : ''"
          :data-plyr-config="JSON.stringify({ quality: '1080', title: selectedVideo ? selectedVideo.title : '' })"
        ></div>
        <video
          v-else
          controls
          crossorigin
          autoplay
          loop
          playsinline
          :data-plyr-config="JSON.stringify({ quality: '1080', title: selectedVideo ? selectedVideo.title : '' })"
        >
          <source :src="combinedPath" type="video/mp4" />
        </video>
      </vue-plyr>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VideoDialog',
  props: {
    value: {
      type: Boolean,
      description: 'Controls whether the dialog is shown'
    },
    videos: {
      type: Array,
      description: 'Videos available in the dialog',
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      selectedVideo: null
    }
  },
  watch: {
    videos: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal.length < 1) return

        this.selectedVideo = newVal[0]
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!this.selectedVideo && this.videos && this.videos.length === 1) this.selectedVideo = this.videos[0]

        if (newVal && this.videos && this.videos.length === 1 && this.selectedVideo) {
          this.$nextTick(() => {
            this.$refs.plyr.player.play()
          })
        }
      }
    }
  },
  computed: {
    ...mapState({
      videoPath: state => state.videoPath
    }),
    specificVideos() {
      return !this.videos || this.videos.length < 1 ? [] : this.videos.filter(x => !x.moi)
    },
    moiVideos() {
      return !this.videos || this.videos.length < 1 ? [] : this.videos.filter(x => x.moi)
    },
    hasPath() {
      return this.videoPath && this.videoPath.url
    },
    combinedPath() {
      let name = this.selectedVideo && this.selectedVideo.video ? this.selectedVideo.video : null
      if (!name) return ''

      if (!this.videoPath || !this.videoPath.url) return name

      let path = this.videoPath.url + (!this.videoPath.url.endsWith('/') ? '/' : '')
      return path + name + '.mp4'
    }
  },
  methods: {
    stopAndClose() {
      this.$refs.plyr.player.stop()
      this.$emit('close')
    },
    selectVideo(video) {
      if (!video || !this.$refs.plyr) return

      // no change
      if (this.selectedVideo && video.video === this.selectVideo.video) return

      this.selectedVideo = video
      this.$refs.plyr.player.stop()
      this.$refs.plyr.player.source = {
        type: 'video',
        title: this.selectedVideo.title,
        sources: [
          {
            src: this.combinedPath,
            provider: !this.hasPath ? 'youtube' : 'video/mp4'
          }
        ]
      }

      this.$nextTick(() => {
        this.$refs.plyr.player.play()
      })
    }
  }
}
</script>
<style scoped>
>>> .noscroll {
  overflow-y: hidden;
  overflow-x: hidden;
}
>>> .video {
  width: 70vw;
}
>>> .videocard {
  width: 100%;
  aspect-ratio: 16/9;
}
</style>
